var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { html, LitElement } from "lit";
import footerCss from "./footer.css.js";
import linksCss from "../../css/links.css.js";
let FooterComponent = class FooterComponent extends LitElement {
    constructor() {
        super();
        this.url = 'https://pb33f.io';
        this.build = '';
    }
    render() {
        const date = new Date().getFullYear();
        return html `
            <footer>
                &copy;${date} <a href="${this.url}">princess b33f heavy industries</a>
                <span class="generated-timestamp">${this.build}</span>
            </footer>`;
    }
};
FooterComponent.styles = [footerCss, linksCss];
__decorate([
    property()
], FooterComponent.prototype, "build", void 0);
__decorate([
    property()
], FooterComponent.prototype, "url", void 0);
FooterComponent = __decorate([
    customElement('pb33f-footer')
], FooterComponent);
export { FooterComponent };
